import $ from 'jquery';
import Swiper from 'swiper';
import flatpickr from 'flatpickr';
import datePickerZhLanguage from 'flatpickr/dist/l10n/zh';

import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';

import '../css/contact-block.css';
import '../css/section-half.css';
import '../css/image-block.css';
import '../css/transportation/map-section/transportation-list.css';

import '../css/common/booking-bar.css';
import '../css/index/promotion-wrapper.css';

import '../../node_modules/swiper/dist/css/swiper.css';
import '../css/swiper-container.css';
import '../css/index/slide-info.css';

import '../../node_modules/flatpickr/dist/flatpickr.min.css';
import '../../node_modules/flatpickr/dist/themes/airbnb.css';
import '../css/room/datepicker.css';
import '../css/common/popup-block.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import { uploadUri, apiUri } from './appConfig';
import wordingSetter from './wordingSetter';
import getWordingJson from './request/wordingJson';
import getMarkedFacilityList from './request/markedFacilityList';
import generateFacilitySlide from './index/generateFacilitySlide';
import updateFacilitySlideInfo from './index/updateFacilitySlideInfo';
import urlParser from './urlParser';
import hideLoadingImage from './common/hideLoadingImage';

setup();

/**
 * temperary pop up block
 */
$('.popup-block > .close-btn, .popup-open').on('click', () => {
	$('.popup-block').toggleClass('-hide');
	$('.popup-open').toggleClass('-show');
});

/**
 * Fetch popup api
 */

const getPopupData = () => {
	fetch(`${apiUri}/advert`)
		.then((res) => res.json())
		.then((result) => {
			const popup = document.querySelector('.popup-block');
			const title = document.querySelector('.popup-block > .title');
			const content = document.querySelector('.popup-block > .content');
			const imageLink = document.querySelector('.popup-block > .image');
			const image = document.querySelector('.popup-block > .image > img');

			if (
				result.data.ad_title === ''
				&& result.data.ad_content === ''
				&& result.data.ad_img === null
			) popup.style.display = 'none';

			if (result.show && result.data) {
				if (result.data.ad_title !== null) title.innerHTML = result.data.ad_title;
				if (result.data.ad_href !== null) title.href = result.data.ad_href;
				if (result.data.ad_content !== null) content.innerHTML = result.data.ad_content;
				if (result.data.ad_img !== null) image.src = `${uploadUri}/${result.data.ad_img}`;
				if (result.data.ad_img === null) image.style.display = 'none';
				if (result.data.d_img_link !== "") imageLink.href = result.data.ad_img_link;
			} else {
				popup.style.display = 'none';
			}
		})
		.catch((err) => console.error(err));
};
getPopupData();
/**
 * add `-index` variant class to show star-hotel
 */
document.querySelector('.footer-wrapper')
	.classList
	.add('-index');

Swiper('.swiper-container.-index', {
	loop: true,
	effect: 'fade',
	autoplay: 3000,
	speed: 1000,
});

/**
 * enable booking module in mobile device
 */
if (window.innerWidth < 768) {
	$('.button-effect.-openBooking').on('click', () => {
		$('.booking-bar').addClass('-show');
	});

	$('.booking-bar > .closebtn').on('click', () => {
		$('.booking-bar').removeClass('-show');
	});
}

/**
 * datepicker setting
 */
flatpickr('.booking-bar > .item:first-child > input', {
	locale: {
		tw: datePickerZhLanguage.zh,
	}[urlParser.language],
	minDate: 'today',
	disableMobile: true,
});

const wordingJsonPromise = getWordingJson('index')
	.then((json) => wordingSetter(json));

const markedFacilityListPromise = getMarkedFacilityList()
	.then((json) => {
		json.facilities.forEach(({ idx_img: image }) => {
			document.querySelector('.swiper-container.-facility > .swiper-wrapper')
				.appendChild(
					generateFacilitySlide(`${uploadUri}/${image}`),
				);
		});

		Swiper('.swiper-container.-facility', {
			pagination: '.swiper-pagination',
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			paginationClickable: true,
			loop: true,
			onSlideChangeStart: (slide) => updateFacilitySlideInfo(json.facilities[slide.realIndex]),
		});
	});

/**
 * make sure each promise is finished
 */
Promise.all([wordingJsonPromise, markedFacilityListPromise])
	.then(() => hideLoadingImage());



// WEBPACK FOOTER //
// ./src/js/index.js